module.exports = __webpack_public_path__ + "static/media/mn.7ff5beba.svg";